import { postTypeGQLFields } from '../post/postType.fields.js';
import { actionPermissionGQLFields, } from './actionPermissions.fields.js';
const BASIC_POST_AUTH_MEMBER_PROPS_FIELDS = {};
const ALL_POST_AUTH_MEMBER_PROPS_FIELDS = {
    permissions: 'basic',
    availableReplyTypes: 'basic',
    canReact: true,
    memberPostNotificationSettingsEnabled: true,
};
export function postAuthMemberPropsGQLFields(fields) {
    if (fields === 'basic')
        fields = BASIC_POST_AUTH_MEMBER_PROPS_FIELDS;
    if (fields === 'all')
        fields = ALL_POST_AUTH_MEMBER_PROPS_FIELDS;
    return `
      context
      scopes
      ${fields.permissions
        ? `
        permissions {
          ${actionPermissionGQLFields(fields.permissions)}
        }
      `
        : ``}
      ${fields.availableReplyTypes
        ? `
          availableReplyTypes {
              ${postTypeGQLFields(fields.availableReplyTypes)}
          }
          `
        : ''}
      ${fields.canReact
        ? `
      canReact
      `
        : ''}
      ${fields.memberPostNotificationSettingsEnabled
        ? `
      memberPostNotificationSettingsEnabled
      `
        : ''}
    `;
}
//# sourceMappingURL=postAuthMemberProps.fields.js.map